/**
 * Serializes filter parameters for list API requests.
 * Preserves explicit booleans (including false) and omits unset values.
 * This replaces the per-builder `if (filters[key])` sanitisation that incorrectly drops false booleans.
 *
 * @param {Object} filters - The filter parameters to serialize
 * @returns {string} Query string (without leading '?')
 */
export function serializeListParams(filters = {}) {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return // omit unset / "All"
    // booleans (true AND false), numbers, and non-empty strings are included
    params.append(key, String(value))
  })
  return params.toString()
}
